module.exports = __webpack_public_path__ + "img/banner-img.8dd6200.png";